
export const getUIAvatar = (fName, lName) => {
  return `https://ui-avatars.com/api/?rounded=true&background=CFFBFC&color=13696C&name=${fName}+${lName}`
}
